// extracted by mini-css-extract-plugin
export default {"wrapper":"Title_wrapper__HYwY+","title":"Title_title__O7mfo","hoverColor":"Title_hoverColor__Nt9+B","hoverMove":"Title_hoverMove__B7J4F","marquee":"Title_marquee__18VKO"};